import _ from 'underscore';
import { FirstPaymentDefinition } from '@ve/types';

type FirstPaymentDefinitionReferenceIndex = {
    [key: number]: FirstPaymentDefinition
};

export default ({ firstPaymentDefinitionIds, firstPaymentDefinitionReferenceIndex }:
                    { firstPaymentDefinitionIds: number[], firstPaymentDefinitionReferenceIndex: FirstPaymentDefinitionReferenceIndex }): FirstPaymentDefinition[] => _.map(firstPaymentDefinitionIds, (routeId: keyof FirstPaymentDefinitionReferenceIndex) => firstPaymentDefinitionReferenceIndex[routeId]);